import { useTheme } from "@emotion/react";
import { Divider, Typography } from "@mui/material";
import HeaderFooter from "./HeaderFooter";

export default function About() {
    const theme = useTheme() as any;

    return (
        <HeaderFooter>
            <Typography style={theme.h1}>About</Typography>

            <Divider style={theme.divider} />

            <Typography mt={1} fontSize='16px'>
                This database and web page have been created as a part of the 
                project funded by the Scientific and Technological Council of 
                Turkey (TÜBİTAK; 118F344), and are managed by the high-energy 
                astrophysics research group at Sabancı University.

            </Typography>

            <Typography mt={2} mb = {1} fontSize='16px'>
                The database is open to public use but please reference our paper if you use the data:
            </Typography>

            <Typography mb = {2} fontSize='16px'>
                Kaneko, Y., Keskin, Ö., Güngör, C., Göğüş¸, E., Uzuner, M. and Ünsal, A.M. 2026, 
                <span style={{color: '#333333' }}> “An 11-Year Catalog of Gamma-ray Transients: A Comprehensive Search with <i>Fermi</i> Gamma-ray Burst Monitor Data”</span>, 
                <i> The Astrophysical Journal Supplement Series</i>, <a href="https://doi.org/10.3847/1538-4365/ae2f60"> DOI: 10.3847/1538-4365/ae2f60</a>
            </Typography>

            <Typography mb = {2} fontSize='16px'>
            All data associated with our paper can also be downloaded from <a href="https://doi.org/10.5281/zenodo.14771272"> https://doi.org/10.5281/zenodo.14771272</a>.
            </Typography>

            <Typography fontSize='16px' mt = {5}>
                <b>Acknowledgement</b><br />
                We thank Mehmet Emin Candar and Tuğrul Ağrikli for their significant contributions in developing this website.
            </Typography>

            
        </HeaderFooter>
    );
}
